import BexLogo from '../../assets/images/logo-expedia-2023.svg';
import travelocityLogo from '../../assets/images/logos/Travelocity.svg';
import ebookersLogo from '../../assets/images/logos/Ebookers.svg';
import cheapTicketsLogo from '../../assets/images/logos/CheapTickets_Logo_RGB.svg';
import wotifLogo from '../../assets/images/logos/Wotif_BrandLogo.jpg';
import orbitzLogo from '../../assets/images/logos/Orbitz.svg';
import hotelsLogo from '../../assets/images/logos/HCom-2023.svg';

export const POS = {
    UAE: 'BEX_UAE',
    AUSTRALIA: 'BEX_AUSTRALIA',
    CHINA: 'BEX_CHINA',
    GERMANY: 'BEX_GERMANY',
    DENMARK: 'BEX_DENMARK',
    SPAIN: 'BEX_SPAIN',
    FINLAND: 'BEX_FINLAND',
    FRANCE: 'BEX_FRANCE',
    CANADA: 'BEX_CANADA',
    USA: 'BEX_USA',
    INDONESIA: 'BEX_INDONESIA',
    ITALY: 'BEX_ITALY',
    JAPAN: 'BEX_JAPAN',
    NETHERLANDS: 'BEX_NETHERLANDS',
    NORWAY: 'BEX_NORWAY',
    NEW_ZEALAND: 'BEX_NEW_ZEALAND',
    BRAZIL: 'BEX_BRAZIL',
    SINGAPORE: 'BEX_SINGAPORE',
    SWEDEN: 'BEX_SWEDEN',
    UK: 'BEX_UK',
    VIETNAM: 'BEX_VIETNAM',
    BELGIUM: 'BEX_BELGIUM',
    AUSTRIA: 'BEX_AUSTRIA',
    MALAYSIA: 'BEX_MALAYSIA',
    INDIA: 'BEX_INDIA',
    TAIWAN: 'BEX_TAIWAN',
    IRELAND: 'BEX_IRELAND',
    PHILIPPINES: 'BEX_PHILIPPINES',
    SWITZERLAND: 'BEX_SWITZERLAND',
    SAUDI_ARABIA: 'BEX_SAUDI_ARABIA',
    EGYPT: 'BEX_EGYPT',
    MEXICO: 'BEX_MEXICO',
    ARGENTINA: 'BEX_ARGENTINA',
    PERU: 'BEX_PERU',
    CHILE: 'BEX_CHILE',
    COLOMBIA: 'BEX_COLOMBIA',
    COSTARICA: 'BEX_COSTARICA',
    SOUTHKOREA: 'BEX_SOUTHKOREA',
    THAILAND: 'BEX_THAILAND',
    HONGKONG: 'BEX_HONGKONG',
    EUROPE: 'BEX_EUROPE',
    TRAVELOCITY_USA: 'TRAVELOCITY_USA',
    CHEAPTICKETS_USA: 'CHEAPTICKETS_USA',
    EBOOKERS_UK: 'EBOOKERS_UK',
    WOTIF_AUSTRALIA: 'WOTIF_AUSTRALIA',
    ORBITZ_USA: 'ORBITZ_USA',
    HCOM_USA: 'HCOM_USA',
    HCOM_ARGENTINA: 'HCOM_ARGENTINA',
    HCOM_AUSTRALIA: 'HCOM_AUSTRALIA',
    HCOM_BELGIUM: 'HCOM_BELGIUM',
    HCOM_BELICE: 'HCOM_BELICE',
    HCOM_BOLIVIA: 'HCOM_BOLIVIA',
    HCOM_BRAZIL: 'HCOM_BRAZIL',
    HCOM_CANADA: 'HCOM_CANADA',
    HCOM_CZECH: 'HCOM_CZECH',
    HCOM_CHILE: 'HCOM_CHILE',
    HCOM_CHINA: 'HCOM_CHINA',
    HCOM_COLOMBIA: 'HCOM_COLOMBIA',
    HCOM_COSTARICA: 'HCOM_COSTARICA',
    HCOM_DANMARK: 'HCOM_DANMARK',
    HCOM_DEUTSCHLAND: 'HCOM_DEUTSCHLAND',
    HCOM_ECUADOR: 'HCOM_ECUADOR',
    HCOM_ESTONIA: 'HCOM_ESTONIA',
    HCOM_ELSALVADOR: 'HCOM_ELSALVADOR',
    HCOM_ESPANA: 'HCOM_ESPANA',
    HCOM_FRANCE: 'HCOM_FRANCE',
    HCOM_GREECE: 'HCOM_GREECE',
    HCOM_GUATEMALA: 'HCOM_GUATEMALA',
    HCOM_GUYANA: 'HCOM_GUYANA',
    HCOM_FRENCHGUIANA: 'HCOM_FRENCHGUIANA',
    HCOM_HONDURAS: 'HCOM_HONDURAS',
    HCOM_HONGKONG: 'HCOM_HONGKONG',
    HCOM_CROATIA: 'HCOM_CROATIA',
    HCOM_INDIA: 'HCOM_INDIA',
    HCOM_INDONESIA: 'HCOM_INDONESIA',
    HCOM_IRELAND: 'HCOM_IRELAND',
    HCOM_ICELAND: 'HCOM_ICELAND',
    HCOM_ISRAEL: 'HCOM_ISRAEL',
    HCOM_ITALY: 'HCOM_ITALY',
    HCOM_JAPAN: 'HCOM_JAPAN',
    HCOM_LATVIA: 'HCOM_LATVIA',
    HCOM_LITHUANIA: 'HCOM_LITHUANIA',
    HCOM_MAGYARORSZAG: 'HCOM_MAGYARORSZAG',
    HCOM_MALAYSIA: 'HCOM_MALAYSIA',
    HCOM_MEXICO: 'HCOM_MEXICO',
    HCOM_NEDERLAND: 'HCOM_NEDERLAND',
    HCOM_NEWZEALAND: 'HCOM_NEWZEALAND',
    HCOM_NICARAGUA: 'HCOM_NICARAGUA',
    HCOM_NORWAY: 'HCOM_NORWAY',
    HCOM_AUSTRIA: 'HCOM_AUSTRIA',
    HCOM_PANAMA: 'HCOM_PANAMA',
    HCOM_PARAGUAY: 'HCOM_PARAGUAY',
    HCOM_PERU: 'HCOM_PERU',
    HCOM_PHILIPPINES: 'HCOM_PHILIPPINES',
    HCOM_POLAND: 'HCOM_POLAND',
    HCOM_PORTUGAL: 'HCOM_PORTUGAL',
    HCOM_AFRICA: 'HCOM_AFRICA',
    HCOM_ASIA: 'HCOM_ASIA',
    HCOM_EUROPE: 'HCOM_EUROPE',
    HCOM_LATAM: 'HCOM_LATAM',
    HCOM_RUSSIA: 'HCOM_RUSSIA',
    HCOM_SINGAPORE: 'HCOM_SINGAPORE',
    HCOM_SLOVAKIA: 'HCOM_SLOVAKIA',
    HCOM_SOUTHAFRICA: 'HCOM_SOUTHAFRICA',
    HCOM_SOUTHKOREA: 'HCOM_SOUTHKOREA',
    HCOM_FINLAND: 'HCOM_FINLAND',
    HCOM_SURINAME: 'HCOM_SURINAME',
    HCOM_SVERIGE: 'HCOM_SVERIGE',
    HCOM_SWITZERLAND: 'HCOM_SWITZERLAND',
    HCOM_TAIWAN: 'HCOM_TAIWAN',
    HCOM_THAILAND: 'HCOM_THAILAND',
    HCOM_MIDDLEEAST: 'HCOM_MIDDLEEAST',
    HCOM_SAUDIARABIA: 'HCOM_SAUDIARABIA',
    HCOM_TURKEY: 'HCOM_TURKEY',
    HCOM_UKRAINE: 'HCOM_UKRAINE',
    HCOM_UK: 'HCOM_UK',
    HCOM_URUGUAY: 'HCOM_URUGUAY',
    HCOM_VENEZUELA: 'HCOM_VENEZUELA',
    HCOM_VIETNAM: 'HCOM_VIETNAM',
    NONE: 'NONE'
};

export const PosList = [
    {
        name: POS.UAE,
        tpid: 1,
        eapid: 2000,
        siteid: 4401,
        langid: 1033,
        localeVR: 'en-us',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.AUSTRALIA,
        tpid: 25,
        eapid: 0,
        siteid: 25,
        langid: 3081,
        localeVR: 'en-au',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.CHINA,
        tpid: 1,
        eapid: 221002,
        siteid: 100001,
        langid: 2052,
        localeVR: 'zh-cn',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.CHINA,
        tpid: 1,
        eapid: 221002,
        siteid: 100001,
        langid: 1033,
        localeVR: 'en-sg',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.GERMANY,
        tpid: 6,
        eapid: 0,
        siteid: 6,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.GERMANY,
        tpid: 6,
        eapid: 0,
        siteid: 6,
        langid: 1031,
        localeVR: 'de-de',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.DENMARK,
        tpid: 67,
        eapid: 0,
        siteid: 67,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.DENMARK,
        tpid: 67,
        eapid: 0,
        siteid: 67,
        langid: 1030,
        localeVR: 'da-dk',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SPAIN,
        tpid: 9,
        eapid: 0,
        siteid: 9,
        langid: 3082,
        localeVR: 'es-es',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SPAIN,
        tpid: 9,
        eapid: 0,
        siteid: 9,
        langid: 1027,
        localeVR: 'es-es',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SPAIN,
        tpid: 9,
        eapid: 0,
        siteid: 9,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.FINLAND,
        tpid: 73,
        eapid: 0,
        siteid: 73,
        langid: 2057,
        localeVR: 'en-gb',
        additionalLocales: ['sv-se', 'en-gb'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.FINLAND,
        tpid: 73,
        eapid: 0,
        siteid: 73,
        langid: 1035,
        localeVR: 'fi-fi',
        additionalLocales: ['sv-se', 'en-gb'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.FRANCE,
        tpid: 20,
        eapid: 0,
        siteid: 20,
        langid: 1036,
        localeVR: 'fr-fr',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.FRANCE,
        tpid: 20,
        eapid: 0,
        siteid: 20,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.CANADA,
        tpid: 4,
        eapid: 0,
        siteid: 4,
        langid: 3084,
        localeVR: 'fr-ca',
        additionalLocales: ['fr-ca', 'en-ca'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.CANADA,
        tpid: 4,
        eapid: 0,
        siteid: 4,
        langid: 4105,
        localeVR: 'en-ca',
        additionalLocales: ['fr-ca', 'en-ca'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.USA,
        tpid: 1,
        eapid: 0,
        siteid: 1,
        langid: 1033,
        localeVR: 'en-us',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.USA,
        tpid: 1,
        eapid: 0,
        siteid: 1,
        langid: 2052,
        localeVR: 'en-sg',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.USA,
        tpid: 1,
        eapid: 0,
        siteid: 1,
        langid: 2058,
        localeVR: 'en-us',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.INDONESIA,
        tpid: 61,
        eapid: 0,
        siteid: 61,
        langid: 1057,
        localeVR: 'en-sg',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.INDONESIA,
        tpid: 61,
        eapid: 0,
        siteid: 61,
        langid: 2057,
        localeVR: 'en-sg',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.ITALY,
        tpid: 8,
        eapid: 0,
        siteid: 8,
        langid: 1040,
        localeVR: 'it-it',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.ITALY,
        tpid: 8,
        eapid: 0,
        siteid: 8,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.JAPAN,
        tpid: 28,
        eapid: 0,
        siteid: 28,
        langid: 1041,
        localeVR: 'ja-jp',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.JAPAN,
        tpid: 28,
        eapid: 0,
        siteid: 28,
        langid: 1033,
        localeVR: 'en-us',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.NETHERLANDS,
        tpid: 11,
        eapid: 0,
        siteid: 11,
        langid: 1043,
        localeVR: 'nl-nl',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.NETHERLANDS,
        tpid: 11,
        eapid: 0,
        siteid: 11,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.NORWAY,
        tpid: 66,
        eapid: 0,
        siteid: 66,
        langid: 1044,
        localeVR: 'no-no',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.NORWAY,
        tpid: 66,
        eapid: 0,
        siteid: 66,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.NEW_ZEALAND,
        tpid: 29,
        eapid: 0,
        siteid: 29,
        langid: 3081,
        localeVR: 'en-nz',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.BRAZIL,
        tpid: 69,
        eapid: 0,
        siteid: 69,
        langid: 1033,
        localeVR: 'en-us',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.BRAZIL,
        tpid: 69,
        eapid: 0,
        siteid: 69,
        langid: 1046,
        localeVR: 'pt-br',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SINGAPORE,
        tpid: 14,
        eapid: 0,
        siteid: 14,
        langid: 2057,
        localeVR: 'en-sg',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SWEDEN,
        tpid: 65,
        eapid: 0,
        siteid: 65,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SWEDEN,
        tpid: 65,
        eapid: 0,
        siteid: 65,
        langid: 1053,
        localeVR: 'sv-se',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.UK,
        tpid: 3,
        eapid: 0,
        siteid: 3,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.VIETNAM,
        tpid: 71,
        eapid: 0,
        siteid: 71,
        langid: 2057,
        localeVR: 'en-sg',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.VIETNAM,
        tpid: 71,
        eapid: 0,
        siteid: 71,
        langid: 1066,
        localeVR: 'vi-vn',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.BELGIUM,
        tpid: 64,
        eapid: 0,
        siteid: 64,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.BELGIUM,
        tpid: 64,
        eapid: 0,
        siteid: 64,
        langid: 1043,
        localeVR: 'nl-nl',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.BELGIUM,
        tpid: 64,
        eapid: 0,
        siteid: 64,
        langid: 1036,
        localeVR: 'fr-fr',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.AUSTRIA,
        tpid: 6,
        eapid: 10122,
        siteid: 10122006,
        langid: 1031,
        localeVR: 'de-at',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.AUSTRIA,
        tpid: 6,
        eapid: 10122,
        siteid: 10122006,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.MALAYSIA,
        tpid: 15,
        eapid: 0,
        siteid: 15,
        langid: 2057,
        localeVR: 'en-sg',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.MALAYSIA,
        tpid: 15,
        eapid: 0,
        siteid: 15,
        langid: 1086,
        localeVR: 'en-sg',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.INDIA,
        tpid: 27,
        eapid: 0,
        siteid: 27,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.TAIWAN,
        tpid: 62,
        eapid: 0,
        siteid: 62,
        langid: 1028,
        localeVR: 'zh-tw',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.TAIWAN,
        tpid: 62,
        eapid: 0,
        siteid: 62,
        langid: 1033,
        localeVR: 'en-sg',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.IRELAND,
        tpid: 63,
        eapid: 0,
        siteid: 63,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.PHILIPPINES,
        tpid: 68,
        eapid: 0,
        siteid: 68,
        langid: 13321,
        localeVR: 'en-sg',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SWITZERLAND,
        tpid: 72,
        eapid: 0,
        siteid: 72,
        langid: 2055,
        localeVR: 'de-de',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SWITZERLAND,
        tpid: 72,
        eapid: 0,
        siteid: 72,
        langid: 4108,
        localeVR: 'fr-fr',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SWITZERLAND,
        tpid: 72,
        eapid: 0,
        siteid: 72,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SAUDI_ARABIA,
        tpid: 1,
        eapid: 2001,
        siteid: 4402,
        langid: 1025,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.EGYPT,
        tpid: 1,
        eapid: 2005,
        siteid: 4406,
        langid: 1033,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.MEXICO,
        tpid: 12,
        eapid: 0,
        siteid: 12,
        langid: 2058,
        localeVR: 'es-es',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.MEXICO,
        tpid: 12,
        eapid: 0,
        siteid: 12,
        langid: 1033,
        localeVR: 'en-us',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.MEXICO,
        tpid: 12,
        eapid: 0,
        siteid: 12,
        langid: 22538,
        localeVR: 'es-xl',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.ARGENTINA,
        tpid: 70,
        eapid: 0,
        siteid: 70,
        langid: 11274,
        localeVR: 'es-es',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.ARGENTINA,
        tpid: 70,
        eapid: 0,
        siteid: 70,
        langid: 1033,
        localeVR: 'en-us',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.PERU,
        tpid: 1,
        eapid: 2002,
        siteid: 4403,
        langid: 2058,
        localeVR: 'es-es',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.PERU,
        tpid: 1,
        eapid: 2002,
        siteid: 4403,
        langid: 1033,
        localeVR: 'en-us',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.CHILE,
        tpid: 1,
        eapid: 2003,
        siteid: 4404,
        langid: 1033,
        localeVR: 'en-us',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.CHILE,
        tpid: 1,
        eapid: 2003,
        siteid: 4404,
        langid: 2058,
        localeVR: 'es-es',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.COLOMBIA,
        tpid: 1,
        eapid: 2004,
        siteid: 4405,
        langid: 2058,
        localeVR: 'es-es',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.COLOMBIA,
        tpid: 1,
        eapid: 2004,
        siteid: 4405,
        langid: 1033,
        localeVR: 'en-us',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.COSTARICA,
        tpid: 1,
        eapid: 2006,
        siteid: 4407,
        langid: 2058,
        localeVR: 'es-es',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.COSTARICA,
        tpid: 1,
        eapid: 2006,
        siteid: 4407,
        langid: 1033,
        localeVR: 'en-us',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SOUTHKOREA,
        tpid: 16,
        eapid: 0,
        siteid: 16,
        langid: 1042,
        localeVR: 'ko-kr',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.SOUTHKOREA,
        tpid: 16,
        eapid: 0,
        siteid: 16,
        langid: 1033,
        localeVR: 'en-sg',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.THAILAND,
        tpid: 17,
        eapid: 0,
        siteid: 17,
        langid: 2057,
        localeVR: 'en-sg',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.THAILAND,
        tpid: 17,
        eapid: 0,
        siteid: 17,
        langid: 1054,
        localeVR: 'th-th',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.HONGKONG,
        tpid: 18,
        eapid: 0,
        siteid: 18,
        langid: 3076,
        localeVR: 'zh-tw',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.HONGKONG,
        tpid: 18,
        eapid: 0,
        siteid: 18,
        langid: 2052,
        localeVR: 'zh-cn',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.HONGKONG,
        tpid: 18,
        eapid: 0,
        siteid: 18,
        langid: 2057,
        localeVR: 'en-sg',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.EUROPE,
        tpid: 63,
        eapid: 400,
        siteid: 4400,
        langid: 2057,
        localeVR: 'en-gb',
        logoInfo: {
            link: BexLogo,
            altText: 'Expedia group logo'
        }
    },
    {
        name: POS.TRAVELOCITY_USA,
        tpid: 80001,
        eapid: 0,
        siteid: 80001,
        langid: 1033,
        localeVR: 'en-us',
        aemSuffix: '_travelocity',
        logoInfo: {
            link: travelocityLogo,
            altText: 'Travelocity Logo'
        }
    },
    {
        name: POS.TRAVELOCITY_USA,
        tpid: 80001,
        eapid: 0,
        siteid: 80001,
        langid: 2058,
        localeVR: 'es-es',
        additionalLocales: ['en-us'],
        aemSuffix: '_travelocity',
        logoInfo: {
            link: travelocityLogo,
            altText: 'Travelocity Logo'
        }
    },
    {
        name: POS.EBOOKERS_UK,
        tpid: 70403,
        eapid: 0,
        siteid: 70403,
        langid: 2057,
        localeVR: 'en-gb',
        aemSuffix: '_ebookers',
        logoInfo: {
            link: ebookersLogo,
            altText: 'Ebookers Logo'
        }
    },
    {
        name: POS.CHEAPTICKETS_USA,
        tpid: 70301,
        eapid: 0,
        siteid: 70301,
        langid: 1033,
        localeVR: 'en-us',
        aemSuffix: '_cheap',
        logoInfo: {
            link: cheapTicketsLogo,
            altText: 'CheapTickets Logo'
        }

    },
    {
        name: POS.WOTIF_AUSTRALIA,
        tpid: 70125,
        eapid: 0,
        siteid: 70125,
        langid: 3081,
        localeVR: 'en-au',
        aemSuffix: '_wotif',
        logoInfo: {
            link: wotifLogo,
            altText: 'Wotif Logo'
        }
    },
    {
        name: POS.ORBITZ_USA,
        tpid: 70201,
        eapid: 0,
        siteid: 70201,
        langid: 1033,
        localeVR: 'en-us',
        aemSuffix: '_orbitz',
        logoInfo: {
            link: orbitzLogo,
            altText: 'Orbitz Logo'
        }
    },
    {
        name: POS.ORBITZ_USA,
        tpid: 70201,
        eapid: 0,
        siteid: 70201,
        langid: 2058,
        localeVR: 'es-es',
        additionalLocales: ['en-us'],
        aemSuffix: '_orbitz',
        logoInfo: {
            link: orbitzLogo,
            altText: 'Orbitz Logo'
        }
    },
    {
        name: POS.HCOM_USA,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-us',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_US-en_US',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_USA,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 21514,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        additionalLocales: ['en-us'],
        utmSource: 'HCOM_US-es_US',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_ARGENTINA,
        tpid: 3019,
        eapid: 3,
        siteid: 301900003,
        langid: 11274,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        additionalLocales: ['en-us', 'es-es'],
        utmSource: 'HCOM_LATAM-es_AR',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_AUSTRALIA,
        tpid: 3201,
        eapid: 35,
        siteid: 300000035,
        langid: 3081,
        localeVR: 'en-au',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_AU-en_AU',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_BELGIUM,
        tpid: 3102,
        eapid: 752,
        siteid: 300000752,
        langid: 1031,
        localeVR: 'de-de',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_BE-de_BE',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_BELGIUM,
        tpid: 4780,
        eapid: 10,
        siteid: 300000010,
        langid: 1036,
        localeVR: 'fr-fr',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_BE-fr_BE',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_BELGIUM,
        tpid: 3105,
        eapid: 9,
        siteid: 300000009,
        langid: 1043,
        localeVR: 'nl-nl',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_BE-nl_BE',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_BELICE,
        tpid: 3019,
        eapid: 3,
        siteid: 301900003,
        langid: 11274,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_BZ',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_BOLIVIA,
        tpid: 3019,
        eapid: 3,
        siteid: 301900003,
        langid: 11274,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_BO',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_BRAZIL,
        tpid: 3018,
        eapid: 3,
        siteid: 301800003,
        langid: 1046,
        localeVR: 'pt-br',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_BR-pt_BR',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_CANADA,
        tpid: 3002,
        eapid: 2,
        siteid: 300000002,
        langid: 4105,
        localeVR: 'en-ca',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_CA-en_CA',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_CANADA,
        tpid: 4780,
        eapid: 10,
        siteid: 300000010,
        langid: 1036,
        localeVR: 'fr-fr',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_CA-fr_CA',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_CZECH,
        tpid: 3130,
        eapid: 22,
        siteid: 300000022,
        langid: 1029,
        localeVR: 'cs-cz',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_CZ-cs_CZ',
        additionalLocales: ['en-gb', 'de-de'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_CHILE,
        tpid: 3019,
        eapid: 3,
        siteid: 301900003,
        langid: 11274,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_CL',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_CHINA,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ASIA-en_CN',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_CHINA,
        tpid: 3019,
        eapid: 3,
        siteid: 301900003,
        langid: 11274,
        localeVR: 'zh-cn',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_CN-zh_CN',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_COLOMBIA,
        tpid: 3127,
        eapid: 3,
        siteid: 312700003,
        langid: 9226,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_CO',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_COSTARICA,
        tpid: 3019,
        eapid: 3,
        siteid: 301900003,
        langid: 11274,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_CR',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_DANMARK,
        tpid: 3110,
        eapid: 13,
        siteid: 300000013,
        langid: 1030,
        localeVR: 'da-dk',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_DK-da_DK',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_DEUTSCHLAND,
        tpid: 3102,
        eapid: 752,
        siteid: 300000752,
        langid: 1031,
        localeVR: 'de-de',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_DE-de_DE',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_ECUADOR,
        tpid: 3019,
        eapid: 3,
        siteid: 301900003,
        langid: 11274,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_EC',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_ESTONIA,
        tpid: 3180,
        eapid: 25,
        siteid: 318000025,
        langid: 1061,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_EE-et_EE',
        additionalLocales: ['en-gb'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_ELSALVADOR,
        tpid: 3019,
        eapid: 3,
        siteid: 301900003,
        langid: 11274,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_SV',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_ESPANA,
        tpid: 3104,
        eapid: 8,
        siteid: 300000008,
        langid: 3082,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ES-es_ES',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_FRANCE,
        tpid: 4780,
        eapid: 10,
        siteid: 300000010,
        langid: 1036,
        localeVR: 'fr-fr',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_FR-fr_FR',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_GREECE,
        tpid: 3180,
        eapid: 21,
        siteid: 300000021,
        langid: 1032,
        localeVR: 'el-gr',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_GR-el_GR',
        additionalLocales: ['en-gb', 'de-de'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_GUATEMALA,
        tpid: 3000,
        eapid: 3,
        siteid: 300000003,
        langid: 4106,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_GT',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_GUYANA,
        tpid: 3000,
        eapid: 3,
        siteid: 300000003,
        langid: 23562,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_GY',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_FRENCHGUIANA,
        tpid: 4780,
        eapid: 10,
        siteid: 300000010,
        langid: 1036,
        localeVR: 'fr-fr',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-fr_GF',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_HONDURAS,
        tpid: 3000,
        eapid: 3,
        siteid: 300000003,
        langid: 18442,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_HN',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_HONGKONG,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ASIA-en_HK',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_HONGKONG,
        tpid: 3205,
        eapid: 39,
        siteid: 300000039,
        langid: 3076,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_HK-zh_HK',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_CROATIA,
        tpid: 3100,
        eapid: 48,
        siteid: 300000048,
        langid: 1050,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_HR-hr_HR',
        additionalLocales: ['en-gb', 'de-de'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_INDIA,
        tpid: 3202,
        eapid: 36,
        siteid: 300000036,
        langid: 16393,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_IN-en_IN',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_INDONESIA,
        tpid: 3212,
        eapid: 46,
        siteid: 321200046,
        langid: 1057,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ID-in_ID',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_INDONESIA,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ASIA-en_ID',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_IRELAND,
        tpid: 3180,
        eapid: 19,
        siteid: 300000019,
        langid: 6153,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_IE-en_IE',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_ICELAND,
        tpid: 3137,
        eapid: 24,
        siteid: 300000024,
        langid: 1039,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_IS-is_IS',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_ISRAEL,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_IL-en_IL',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_ISRAEL,
        tpid: 3113,
        eapid: 16,
        siteid: 300000016,
        langid: 1037,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_IL-iw_IL',
        additionalLocales: ['en-gb'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_ITALY,
        tpid: 3103,
        eapid: 7,
        siteid: 300000007,
        langid: 1040,
        localeVR: 'it-it',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_IT-it_IT',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_JAPAN,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ASIA-en_JP',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_JAPAN,
        tpid: 3203,
        eapid: 37,
        siteid: 300000037,
        langid: 1041,
        localeVR: 'ja-jp',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_JP-ja_JP',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_LATVIA,
        tpid: 3180,
        eapid: 29,
        siteid: 300000029,
        langid: 1062,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LV-lv_LV',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_LITHUANIA,
        tpid: 3180,
        eapid: 30,
        siteid: 300000030,
        langid: 1063,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LT-lt_LT',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_MAGYARORSZAG,
        tpid: 3131,
        eapid: 23,
        siteid: 300000023,
        langid: 1038,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_HU-hu_HU',
        additionalLocales: ['en-gb', 'de-de'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_MALAYSIA,
        tpid: 3210,
        eapid: 43,
        siteid: 300000043,
        langid: 1086,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_MY-ms_MY',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_MALAYSIA,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ASIA-en_MY',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_MEXICO,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-us',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-en_MX',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_MEXICO,
        tpid: 3000,
        eapid: 3,
        siteid: 300000003,
        langid: 2058,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_MX',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_NEDERLAND,
        tpid: 3105,
        eapid: 9,
        siteid: 300000009,
        langid: 1043,
        localeVR: 'nl-nl',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_NL-nl_NL',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_NEWZEALAND,
        tpid: 3204,
        eapid: 38,
        siteid: 300000038,
        langid: 5129,
        localeVR: 'en-nz',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_NZ-en_NZ',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_NICARAGUA,
        tpid: 3000,
        eapid: 3,
        siteid: 300000003,
        langid: 19466,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_NI',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_NORWAY,
        tpid: 3109,
        eapid: 12,
        siteid: 300000012,
        langid: 1044,
        localeVR: 'no-no',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_NO-no_NO',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_AUSTRIA,
        tpid: 3180,
        eapid: 20,
        siteid: 300000020,
        langid: 3079,
        localeVR: 'de-at',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_AT-de_AT',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_PANAMA,
        tpid: 3000,
        eapid: 3,
        siteid: 300000003,
        langid: 6154,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_PA',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_PARAGUAY,
        tpid: 3000,
        eapid: 3,
        siteid: 300000003,
        langid: 15370,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_PY',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_PERU,
        tpid: 3000,
        eapid: 3,
        siteid: 300000003,
        langid: 10250,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_PE',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_PHILIPPINES,
        tpid: 3214,
        eapid: 44,
        siteid: 300000044,
        langid: 13321,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_PH-en_PH',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_POLAND,
        tpid: 3116,
        eapid: 26,
        siteid: 300000026,
        langid: 1045,
        localeVR: 'pl-pl',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_PL-pl_PL',
        additionalLocales: ['en-gb', 'de-de'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_PORTUGAL,
        tpid: 3180,
        eapid: 27,
        siteid: 300000027,
        langid: 2070,
        localeVR: 'pt-pt',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_PT-pt_PT',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_AFRICA,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_EMEA-en_IE',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_ASIA,
        tpid: 3001,
        eapid: 1,
        siteid: 30000000,
        langid: 1033,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ASIA-en_AS',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_EUROPE,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_EMEA-en_IE',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_LATAM,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-us',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-en_LA',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_RUSSIA,
        tpid: 3112,
        eapid: 15,
        siteid: 300000015,
        langid: 1049,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_RU-ru_RU',
        additionalLocales: ['en-gb', 'de-de'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_SINGAPORE,
        tpid: 3206,
        eapid: 40,
        siteid: 300000040,
        langid: 18441,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_SG-en_SG',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_SLOVAKIA,
        tpid: 3180,
        eapid: 31,
        siteid: 300000031,
        langid: 1051,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_SK-sk_SK',
        additionalLocales: ['en-gb', 'de-de'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_SOUTHAFRICA,
        tpid: 3114,
        eapid: 32,
        siteid: 300000032,
        langid: 7177,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ZA-en_ZA',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_SOUTHKOREA,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ASIA-en_KR',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_SOUTHKOREA,
        tpid: 3207,
        eapid: 41,
        siteid: 300000041,
        langid: 1042,
        localeVR: 'ko-kr',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_KR-ko_KR',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_FINLAND,
        tpid: 3180,
        eapid: 18,
        siteid: 300000018,
        langid: 1035,
        localeVR: 'fi-fi',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_FI-fi_FI',
        additionalLocales: ['en-gb', 'sv-se'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_SURINAME,
        tpid: 3105,
        eapid: 9,
        siteid: 300000009,
        langid: 1043,
        localeVR: 'nl-nl',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-nl_SR',
        additionalLocales: ['nl-nl', 'en-us'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_SVERIGE,
        tpid: 3107,
        eapid: 11,
        siteid: 300000011,
        langid: 1053,
        localeVR: 'sv-se',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_SE-sv_SE',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_SWITZERLAND,
        tpid: 3111,
        eapid: 14,
        siteid: 300000014,
        langid: 2055,
        localeVR: 'de-de',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_CH-de_CH',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_SWITZERLAND,
        tpid: 4780,
        eapid: 10,
        siteid: 300000010,
        langid: 1036,
        localeVR: 'fr-fr',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_CH-fr_CH',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_SWITZERLAND,
        tpid: 3103,
        eapid: 7,
        siteid: 300000007,
        langid: 1040,
        localeVR: 'it-it',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_CH-it_CH',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_TAIWAN,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ASIA-en_TW',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_TAIWAN,
        tpid: 3211,
        eapid: 45,
        siteid: 300000045,
        langid: 1028,
        localeVR: 'zh-tw',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_TW-zh_TW',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_THAILAND,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ASIA-en_TH',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_THAILAND,
        tpid: 3209,
        eapid: 46,
        siteid: 300000046,
        langid: 1054,
        localeVR: 'th-th',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_TH-th_TH',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_MIDDLEEAST,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ME-en_IE',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_SAUDIARABIA,
        tpid: 3117,
        eapid: 33,
        siteid: 300000033,
        langid: 14337,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ARABIC-ar_AE',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_TURKEY,
        tpid: 3115,
        eapid: 28,
        siteid: 300000028,
        langid: 1055,
        localeVR: 'tr-tr',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_TR-tr_TR',
        additionalLocales: ['en-gb'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_UKRAINE,
        tpid: 3100,
        eapid: 49,
        siteid: 300000049,
        langid: 1058,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_UA-uk_UA',
        additionalLocales: ['en-gb', 'de-de'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_UK,
        tpid: 3101,
        eapid: 5,
        siteid: 300000005,
        langid: 2057,
        localeVR: 'en-gb',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_UK-en_GB',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_URUGUAY,
        tpid: 3000,
        eapid: 3,
        siteid: 300000003,
        langid: 14346,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_UY',
        additionalLocales: ['en-us', 'es-es'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_VENEZUELA,
        tpid: 3000,
        eapid: 3,
        siteid: 300000003,
        langid: 8202,
        localeVR: 'es-es',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_LATAM-es_VE',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_VIETNAM,
        tpid: 3001,
        eapid: 1,
        siteid: 300000001,
        langid: 1033,
        localeVR: 'en-sg',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_ASIA-en_VN',
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.HCOM_VIETNAM,
        tpid: 3213,
        eapid: 0,
        siteid: 3213,
        langid: 1066,
        localeVR: 'vi-vn',
        aemSuffix: '_hotels',
        utmSource: 'HCOM_VN-vi_VN',
        additionalLocales: ['en-sg'],
        logoInfo: {
            link: hotelsLogo,
            altText: 'Hotels Logo'
        }
    },
    {
        name: POS.NONE,
        tpid: 0,
        eapid: 0,
        siteid: 0,
        langid: 0,
        localeVR: ''
    }
];

export const LocaleToTpid = {
    en_US: 1, // English (US)
    es_ES: 9, // Español (España)
    it_IT: 8, // Italiano
    fr_FR: 20, // Français
    fr_CA: 4, // Français (Canadien)
    de_DE: 6, // Deutsch
    de_AT: 3180, // Deutsch (AT)
    ru_RU: 3112, // Русский (RU)
    pt_BR: 69, // Português (Brasileiro)
    ja_JP: 28, // 日本語 Japanese
    ko_KR: 16, // South korea
    vi_VN: 71, // Vietnam
    zh_CN: 18, // China zh_CN
    zh_TW: 62, // zh_TW taiwan
    zh_HK: 3205, // Hong Kong zh_HK
    tr_TR: 3115, // Türkçe (TR)
    nl_NL: 11, // Nederlands
    th_TH: 17, // ไทย (TH)
    el_GR: 3180, // Ελληνικά (GR) Greece
    pt_PT: 3180, // Português (PT) Portugal
    en_GB: 3, // English (UK) },
    en_AU: 3201, // English (AU)
    en_NZ: 3204, // English (NZ)
    en_LK: 3, // LK is supposed to be Sri Lanka, no POS; defaults to UK
    en_SG: 3206, // English (SG)
    en_CA: 3002, // English (CA)
    sv_SE: 3107, // Svenska (SE)
    pl_PL: 3116, // Polski (PL)
    nb_NO: 3109, // Norway
    hr_HR: 3100, // Croatia
    da_DK: 3110, // Denmark
    fi_FI: 3180, // Finland
    cs_CZ: 3130, // Czech Republic
    hu_HU: 3131, // Hungary
    ar_SA: 3, // Arabic (SA) - no POS; defaults to UK
    he_IL: 3313 // Hebrew (IL)
};

export default {
    POS
};
